export const environment = {
  name: "FT",
  apiUrl: "/services", // https://ftf.cir.fiscal.treasury.gov/cir/api/
  privateAppUrl: "/private/",
  defaultApiVersion: "v1",
  production: false,
  mockBackend: false,
  version: '3.0.22',
  branch: '',
  buildNumber: '',
  buildTime: '2026-11-03T18:41:58Z',
  commit: '',
  fullVersion: '3.0.22'
};
